/**
 * Lê os parâmetros que vêm DEPOIS do `?` dentro do hash da rota.
 *
 * O app usa hash routing, então o link do e-mail chega como
 * `/#/set-password?access_token=…`. O `getSearchString` do ra-supabase-core
 * resolve isso, mas com uma armadilha: ele prefere `window.location.search` e
 * só olha o hash quando a query "de verdade" está vazia. Basta a URL ganhar
 * qualquer `?parametro` — o `__build` que o AppVersionMonitor usa para forçar
 * recarga, um `utm_` que o cliente de e-mail cola no link — para os tokens do
 * hash serem ignorados e a tela de senha dizer que eles estão faltando.
 *
 * Aqui a gente lê só o hash, que é onde os tokens realmente estão.
 */
export const getHashQueryParams = (): URLSearchParams => {
  const hash = window.location.hash.substring(1);
  const inicio = hash.indexOf("?");
  return new URLSearchParams(inicio === -1 ? "" : hash.slice(inicio + 1));
};
